import '../common.css'
import './scheme.css'
import './tailor-made.css'